<template>
  <div class="course-box">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>培训课程</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部" name="all"></el-tab-pane>
      <el-tab-pane label="待审核" name="audit"></el-tab-pane>
      <el-tab-pane label="我创建的" name="created"></el-tab-pane>
    </el-tabs>
    <div>
      <PublicSearch class="user-search" :searchData="searchData"
        @onSearch="() => { pageInfo.currentPage = 1; getData() }">
        <template #clazzName>{{ $store.state.institution }}</template>

        <template #right>
          <el-button v-buttonAuth="'system:course:add'" v-if="activeName !== 'audit'" size="small" type="primary"
            class="mg-btm20" @click="handleAction(1)">新增</el-button>

          <el-popconfirm title="是否批量通过？" @confirm="batchCell(1)">
            <el-button type="primary" slot="reference" size="small" v-show="activeName == 'audit'"
              :disabled="checkList.length == 0" v-buttonAuth="'system:course:audit'">批量通过</el-button>
          </el-popconfirm>
          <el-popconfirm title="是否批量驳回？" @confirm="batchCell(2)">
            <el-button type="error" slot="reference" size="small" v-show="activeName == 'audit'"
              :disabled="checkList.length == 0" v-buttonAuth="'system:course:audit'">批量驳回</el-button>
          </el-popconfirm>

        </template>
      </PublicSearch>
    </div>
    <my-table height="64%" :columns="customColumns" :tableData="tableData" :loading="isLoading"
      @selection-change="handleSelectionChange" @row-click="handleRowClick">

      <template #deptName="item">{{ item.row.create ? item.row.create.deptName : '无' }}</template>

      <template #publishSign="item">{{ item.row.publishSign ? '已发布' : '未发布' }}</template>
      <el-table-column prop="userSex" width="380px" label="操作">

        <template slot-scope="scope">
          <div class="d-flex fz14 col-29f cs-pit">
            <div v-buttonAuth="'system:course:view'" class="operate" @click="handleAction(3, scope)">查看</div>

            <div v-show="!scope.row.publishSign && scope.row.approvalStatus == 'no'" class="operate"
              @click="handleAction(1, scope)">
              <span v-buttonAuth="'system:course:edit'">编辑</span>
            </div>
            <div v-show="!scope.row.publishSign && scope.row.approvalStatus == 'no'" class="operate"
              @click="handleAction(2, scope)">
              <span v-buttonAuth="'system:course:release'">发布</span>
            </div>

            <div v-buttonAuth="'system:course:learningRecords'" v-show="scope.row.approvalStatus == 'pass'"
              class="operate" @click="handleAction(4, scope)">学习记录
            </div>
            <div v-buttonAuth="'system:course:review'" class="operate" v-show="scope.row.approvalStatus == 'pass'"
              @click="handleAction(5, scope)">评论管理</div> &nbsp;
            <el-popconfirm :title="scope.row.hidden ? '确认显示么' : '隐藏课程后，学员在课程列表中不可见，请确定是否隐藏？'"
              @confirm="handleAction(6, scope)">
              <div v-buttonAuth="'system:course:hide'" slot="reference" class="operate"
                v-show="scope.row.approvalStatus == 'pass'">{{
                  scope.row.hidden ? '显示' : '隐藏' }}</div>
            </el-popconfirm>


            <el-popconfirm title="删除课程后将同步清空学员的学习记录，请确定是否删除？" @confirm="removeExam(scope.$index, scope.row)">
              <div type="text" slot="reference" class="col-f4d" style="margin-left:10px ;"
                v-buttonAuth="'system:course:delete'">删除</div>
            </el-popconfirm>
            <div class="operate" v-buttonAuth="'system:course:audit'" v-if="scope.row.approvalStatus === 'todo'"
              @click="handleAction(7, scope)">审核</div>
            <div class="operate" v-buttonAuth="'system:course:allot'" v-if="scope.row.approvalStatus === 'todo'"
              @click="handleAction(8, scope)">分配审核人</div>
          </div>
        </template>
      </el-table-column>
    </my-table>
    <div class="main-pagination">
      <Pagination :child-msg="pageInfo" @callFather="callFather"></Pagination>
    </div>
    <!-- 编辑界面 -->
    <el-dialog :title="dialogData.title" :visible.sync="dialogData.visible" width="50%">
      <div class="view-list" v-if="dialogData.title.includes('查看')">
        <div v-for="(item, index) in dialogData.viewList" :key="index">
          <div class="view-item">
            <div class="view-label line-ht" style="text-overflow: ellipsis;white-space: nowrap;">{{ item.label }}：</div>
            <div class="flex-1 line-ht">
              <div v-if="item.prop === 'material'" class="" style="overflow-x: auto">
                <el-table :data="dialogData.viewForm[item.prop]" border style="width: 100%">
                  <el-table-column prop="materialTypeText" label="文件类型" width="180"></el-table-column>
                  <el-table-column prop="name" label="文件名称"></el-table-column>
                  <el-table-column label="操作" width="180">

                    <template slot-scope="scope">
                      <span class="col-29f cs-pit mg-lef10" v-buttonAuth="'system:course:downloadFile'"
                        @click="fileDownload(URL + scope.row.fileKey, scope.row.name)">下载</span>
                      <span class="col-29f cs-pit" v-buttonAuth="'system:course:reviewFile'"
                        @click="fileReview(URL + scope.row.fileKey, scope.row.name, scope.row)">查看</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else-if="item.prop === 'cover'">
                <el-image v-if="dialogData.viewForm[item.prop]" style="width: 150px; height: 150px"
                  :src="URL + dialogData.viewForm[item.prop]" fit="cover"></el-image>
                <span v-else>无</span>
              </div>
              <div v-else>{{ dialogData.viewForm[item.prop] || '无' }}</div>
            </div>
          </div>
          <div class="fz12" style="width: 100%;padding-left: 60px;" v-if="item.tips">{{ item.tips }}</div>
        </div>
      </div>
      <div v-else>
        <my-form ref="editForm" :form-config="dialogData.commonList" :dataForm="dialogData.form"
          :formRules="dialogData.rules">

          <template #material>
            <my-upload :fileList="dialogData.form.materialFileList" :config="{ autoUpload: false, limit: 10 }"
              @upload-remove="uploadRemove" @uploadChange="uploadChange">
              <template #upload-button>
                <el-button size="small" type="primary">点击上传</el-button>
              </template>

              <template #tip>
                <div v-html="'注：仅支持word（docx）、excel（xlsx）、视频（mp4、avi、wmv、mpeg、flv、rm）、pdf、png、jpg、jpeg格式上传'"></div>
              </template>
            </my-upload>
          </template>

          <template #cover>
            <my-upload :class="dialogData.form.coverFileList.length === 1 ? 'fileLimit-box' : ''"
              :fileList="dialogData.form.coverFileList"
              :config="{ listType: 'picture-card', customAction: '/api/file/upload', limit: 1 }"
              @upload-remove="handleRemove" @upload-success="handleSuccess" @upload-preview="handlePreview"
              @beforeUpload="beforeUpload">
              <template #tip>
                <div v-html="'注：仅支持png、jpg、jpeg格式上传'"></div>
              </template>
            </my-upload>
          </template>
        </my-form>
        <div slot="footer" class="dialog-footer text-rgt">
          <el-button size="small" @click='dialogData.visible = false'>取消</el-button>
          <el-button size="small" type="primary" :loading="dialogData.loading" @click="submitForm()">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="查看" :visible.sync="reviewDialog.visible" width="50%">
      <reviewOffice :type="reviewDialog.type" v-if="reviewDialog.visible" :url="reviewDialog.url"></reviewOffice>
    </el-dialog>
    <el-dialog title="文件上传中" :show-close="false" :visible="$store.state.progress > -1" width="50%">
      <span class="d-flex flex-align-center" style="margin-top: 20px;margin-bottom: 20px;font-size: 18px;"
        v-if="$store.state.progress == 100">
        合并转存中，请稍后...
      </span>
      <div class="d-flex flex-align-center ">
        <el-progress style="flex:1;" :text-inside="true" :loading="true" :stroke-width="24"
          :percentage="$store.state.progress == -1 ? 0 : $store.state.progress" status="success"></el-progress>
        <img src="@/assets/img/loading.gif" alt="" style="margin-left: 10px;width: 20px;
    height: 20px;">
      </div>
    </el-dialog>
    <!-- 审核 -->
    <el-dialog title="审核" :show-close="false" :visible="auditDialog.visible" width="50%">
      <div class="view-list">

        <div v-for="(item, index) in dialogData.viewList" :key="index">
          <div class="view-item">
            <div class="view-label line-ht" style="text-overflow: ellipsis;white-space: nowrap;">{{ item.label }}：</div>
            <div class="flex-1 line-ht">
              <div v-if="item.prop === 'material'" class="" style="overflow-x: auto">
                <el-table :data="dialogData.viewForm[item.prop]" border style="width: 100%">
                  <el-table-column prop="materialTypeText" label="文件类型" width="180"></el-table-column>
                  <el-table-column prop="name" label="文件名称"></el-table-column>
                  <el-table-column label="操作" width="180">

                    <template slot-scope="scope">
                      <span class="col-29f cs-pit mg-lef10" v-buttonAuth="'system:course:downloadFile'"
                        @click="fileDownload(URL + scope.row.fileKey, scope.row.name)">下载</span>
                      <span class="col-29f cs-pit" v-buttonAuth="'system:course:reviewFile'"
                        @click="fileReview(URL + scope.row.fileKey, scope.row.name, scope.row)">查看</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else-if="item.prop === 'cover'">
                <el-image v-if="dialogData.viewForm[item.prop]" style="width: 150px; height: 150px"
                  :src="URL + dialogData.viewForm[item.prop]" fit="cover"></el-image>
                <span v-else>无</span>
              </div>
              <div v-else>{{ dialogData.viewForm[item.prop] || '无' }}</div>
            </div>
          </div>
          <div class="fz12" style="width: 100%;padding-left: 60px;" v-if="item.tips">{{ item.tips }}</div>
        </div>
      </div>
      <hr>
      <my-form ref="auditForm" :form-config="auditDialog.commonList" :dataForm="auditDialog.form"
        :formRules="auditDialog.rules">
      </my-form>
      <div slot="footer" class="dialog-footer text-rgt">
        <el-button size="small" @click='auditDialog.visible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="auditDialog.loading" @click="submitFormAudit()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 分配审核人 -->
    <el-dialog title="分配审核人" :visible.sync="auditPersonDialog.visible" width="50%">
      <my-form ref="editForm1" :form-config="auditPersonDialog.commonList" :dataForm="auditPersonDialog.form"
        :formRules="auditPersonDialog.rules">
      </my-form>
      <div slot="footer" class="dialog-footer text-rgt">
        <el-button size="small" @click='auditPersonDialog.visible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="auditPersonDialog.loading"
          @click="submitFormPerson()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 批量驳回 -->
    <el-dialog title="批量驳回" :visible.sync="rejectDialog.visible" width="50%">
      <my-form ref="rejectForm" :form-config="rejectDialog.commonList" :dataForm="rejectDialog.form"
        :formRules="rejectDialog.rules">
      </my-form>
      <div slot="footer" class="dialog-footer text-rgt">
        <el-button size="small" @click='rejectDialog.visible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="rejectDialog.loading"
          @click="submitFormReject()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PublicSearch from '@/components/publicSearch.vue';
import MyUpload from '@/components/myUpload.vue';
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import reviewOffice from '@/components/reviewOffice'
import myForm from '@/components/myForm.vue';
import { archiveList } from '@/api/employee';
import api from '../../../api/onlineTraining/course';
import classificationApi from '../../../api/onlineTraining/classification';
import { examPaperList } from '../../../api/exam';
import { section, calculateHash, uploadChunks } from '../../../utils/fileSection';
import { fileDownload } from "../../../utils/util";
import { deptTree } from "../../../api/dept";
import vuePdf from 'vue-pdf';
export default {
  components: {
    PublicSearch,
    MyUpload,
    MyTable,
    Pagination,
    myForm,
    vuePdf,
    reviewOffice

  },
  data () {
    return {
      activeName: 'all',
      searchData: {
        inputList: [
          { label: '所属机构：', prop: 'clazzName' },
          { label: '课程名称：', prop: 'courseName', type: 'input', placeholder: '请输入课程名称' },
          { label: '科目类别：', prop: 'courseCategoryId', type: 'select', placeholder: '请选择科目类别', dictionary: [] },
          { label: '发布状态：', prop: 'publishSign', type: 'select', placeholder: '请选择发布状态', dictionary: [] },
          {
            label: '部门',
            prop: 'deptId',
            props: 'dept',
            type: 'caScaDer',
            ref: 'casCaDerOne',
            options: [],
            casCaDerProps: { label: 'deptName', value: 'deptId', checkStrictly: true, Show: false, emitPath: false }
          },
          { label: '审核状态：', prop: 'approvalStatus', type: 'select', placeholder: '请选择发布状态', dictionary: [] },

          // { label: '级别：', prop: 'level', type: 'select', placeholder: '请选择级别', dictionary: [] }
        ],
        searchQuery: { selectSign: '', approvalStatus: '' } //  搜索参数
      }, //  搜索参数
      customColumns: [
        { label: '所属机构', prop: '', formatter: () => { return this.$store.state.institution } },
        { label: '课程编码', prop: 'courseCode' },
        { label: '课程名称', prop: 'courseName' },
        { label: '科目类别', prop: 'courseCategoryName' },
        // { label: '级别', prop: 'levelText' },
        // { label: '素材类型', prop: 'type' },
        { label: '创建人', prop: 'createBy' },
        { label: '创建人所属部门', prop: 'deptName', slot: 'deptName' },
        { label: '创建时间', prop: 'createTime' },
        { label: '发布状态', slot: 'publishSign' },
        { label: '审核状态', prop: 'approvalStatusText' }//todo-待审核,pass-已通过,reject-已驳回
      ],
      isLoading: false,
      checkList: [],
      tableData: [],
      pageInfo: { currentPage: 1, pageSize: 10, total: 0 }, //  分页参数
      dialogData: {
        title: '',
        visible: false,
        loading: false,
        commonList: [
          { type: 'input', prop: 'courseName', label: '课程名称', placeholder: '请输入课程名称' },
          { type: 'select', prop: 'courseCategoryId', label: '科目类别', options: [] },
          // { type: 'select', prop: 'level', label: '所属级别', options: [] },
          { type: 'input', prop: 'keyword', label: '关键字', placeholder: '请输入关键字' },
          { prop: 'material', label: '素材', placeholder: '请输入分类名称' },
          {
            prop: 'cover',
            label: '封面',
            placeholder: '请输入分类名称',
            property: { config: { listType: 'picture-card', customAction: '' } }
          },
          { type: 'textarea', prop: 'synopsis', label: '教程简介', placeholder: '请输入教程简介', maxlength: 500 },
          { type: 'number', prop: 'classHour', label: '学时', min: 0.1, tips: '注：1学时为45分钟' },
          // { type: 'select', prop: 'examPaperId', label: '绑定试卷', placeholder: '请选择试卷', options: [] }
        ],
        form: { materialFileList: [], coverFileList: [] },
        viewList: [
          { label: '课程名称', prop: 'courseName' },
          { label: '科目类别', prop: 'courseCategoryName' },
          // { label: '所属级别', prop: 'levelText' },
          { label: '关键字', prop: 'keyword' },
          { label: '素材', prop: 'material' },
          { label: '封面', prop: 'cover' },
          { label: '教程简介', prop: 'synopsis' },
          { label: '学时', prop: 'classHour', tips: '注：1学时为45分钟' },
          // { label: '绑定试卷', prop: 'examName' }
        ],
        viewForm: {}, //  查看数据
        rules: {
          courseName: { required: true, message: '请输入课程名称', trigger: 'blur' },
          courseCategoryId: { required: true, message: '请选择科目类别', trigger: 'change' },
          keyword: { required: true, message: '请输入关键字', trigger: 'blur' },
          material: { required: true, message: '请输入选择素材', trigger: 'blur' },
          synopsis: { required: true, message: '请输入教程简介', trigger: 'blur' },
          classHour: { required: true, message: '请输入', trigger: 'blur' }
        }
      }, //  弹窗
      URL: envConfig.NODE_IMG_API,
      reviewDialog: {
        visible: false,
        url: '',
        type: ''
      },
      auditDialog: {
        visible: false,
        url: '',
        type: '',
        form: {
          approvalStatus: 'pass',
          approvalReasons: '',

          courseId: '',
        },
        loading: false,

        commonList: [

          {
            type: 'radio', prop: 'approvalStatus', label: '审核结果:', options: [
              {
                label: '通过',
                id: 'pass'
              },
              {
                label: '驳回',
                id: 'reject'
              }

            ]
          },
          { type: 'textarea', prop: 'approvalReasons', label: '审核意见' },
        ],
        rules: {
          approvalStatus: { required: true, message: '请选择审核结果', trigger: 'change' },
        },


      },
      auditPersonDialog: {
        courseId: '',
        visible: false,
        loading: false,
        commonList: [
          {
            type: 'select', prop: 'userIds', label: '选择人员', options: [],
            property: {
              clearable: true,
              filterable: true,
              multiple: true,
              'collapse-tags': true,
              'collapse-tags-tooltip': true,
            },
          },

        ],
        form: { userIds: [] },

        viewForm: {}, //  查看数据
        rules: {
          userIds: { required: true, message: '请选择人员', trigger: 'change' },
        }
      },
      rejectDialog: {
        visible: false,
        loading: false,
        commonList: [
          {
            type: 'textarea', prop: 'approvalReasons', label: '审核意见', maxlength: 50,
          },
        ],
        form: { approvalReasons: '' },
        viewForm: {}, //  查看数据
        rules: {
          approvalReasons: { required: true, message: '请输入审核意见', trigger: 'change' },
        }
      },
    }
  },

  watch: {
    async 'dialogData.form.courseCategoryId' (i) {
      // if (i) {
      //   const examPaperRes = await examPaperList({ publishStatus: true, courseCategoryId: i });
      //   this.dialogData.commonList[8].options = examPaperRes.data.map(item => {
      //     return Object.assign(item, { label: item.examName, id: item.examPaperId });
      //   })
      // } else this.dialogData.commonList[8].options = [];
    }
  },
  created () {
    this.getDictionary();
    this.getData();
  },
  methods: {
    fileDownload,
    submitFormAudit () {
      this.$refs.auditForm.$refs.form.validate(async valid => {
        if (valid) {
          const res = await api.approval({
            ...this.auditDialog.form,
          });
          await this.getData();
          this.auditDialog.visible = false
          this.$message.success(res.msg);
        } else {
          return false
        }
      })

    },
    submitFormPerson () {
      this.$refs.editForm1.$refs.form.validate(async valid => {
        if (!valid) return false;
        const params = {
          "courseId": this.auditPersonDialog.courseId,
          "hasApprovalUserIds": this.auditPersonDialog.form.userIds
        }
        api.addHasApprovalUser(params).then(res => {
          this.auditPersonDialog.visible = false;
          this.getData();
          this.auditPersonDialog.form.userIds = [];
          this.$message({ message: '分配成功', type: 'success' });
        })
      })
    },
    batchCell (index) {
      if (index == 1) {
        const params = {
          "courseIds": this.checkList.map(el => el.courseId),
          approvalStatus: 'pass',
          "approvalReasons": ''
        }
        api.approval(params).then(res => {
          this.rejectDialog.visible = false;
          this.getData();
          this.$message.success(res.msg)
        })
      } else {
        this.rejectDialog.form.courseIds = this.checkList.map(el => el.courseId);
        this.rejectDialog.visible = true
        this.rejectDialog.form.approvalReasons = '';
      }

    },
    submitFormReject () {
      this.$refs.rejectForm.$refs.form.validate(async valid => {
        if (!valid) return false;
        const params = {
          "courseIds": this.rejectDialog.form.courseIds,
          approvalStatus: 'reject',
          "approvalReasons": this.rejectDialog.form.approvalReasons
        }
        api.approval(params).then(res => {
          this.rejectDialog.visible = false;
          this.getData();
          this.$message({ message: '驳回成功', type: 'success' });
        })
      })
    },
    handleClick () {
      this.searchData.searchQuery = {};
      this.searchData.inputList[3].hide = this.activeName == 'audit'
      this.searchData.inputList[5].hide = this.activeName == 'audit'
      this.pageInfo.currentPage = 1;
      this.getData()

    },
    async getDictionary () {
      const res = await classificationApi.courseCategoryList({ stateSign: true });
      this.searchData.inputList[2].dictionary = this.dialogData.commonList[1].options = res.data.map(item => {
        return Object.assign(item, { label: item.courseCategoryName, id: item.courseCategoryId });
      })
      this.searchData.inputList[3].dictionary = [
        { label: '已发布', id: true },
        { label: '未发布', id: false }
      ]
      this.searchData.inputList[5].dictionary = [
        { label: '待审核', id: 'todo' },
        { label: '已通过', id: 'pass' },
        { label: '已驳回', id: 'reject' },
      ]
      const ress = await deptTree();
      this.searchData.inputList[4].options = ress.data;
      // this.searchData.inputList[4].dictionary = this.dialogData.commonList[2].options = [
      //   { label: '公司级', id: 'company' },
      //   { label: '车间级', id: 'workshop' },
      //   { label: '班组级', id: 'unit' },
      //   { label: '其他级', id: 'other' }
      // ]
      const resss = await archiveList({});
      this.auditPersonDialog.commonList[0].options = resss.data.map(i => { return { id: i.archiveId, label: i.userName + `(${i.deptName})` } })

    },
    //  改变分页及大小
    callFather (data) {
      this.pageInfo.currentPage = data.currentPage;
      this.pageInfo.pageSize = data.pageSize;
      this.getData();
    },
    //  获取数据
    async getData () {
      this.checkList = []
      const params = {
        ...this.searchData.searchQuery,
        pageNum: this.pageInfo.currentPage,
        pageSize: this.pageInfo.pageSize,
        createId: this.activeName === 'created' ? this.$store.state.userInfo.userId : '',
      };
      if (this.activeName === 'audit') {
        params.approvalStatus = 'todo'
      }
      const apiType = this.activeName === 'audit' ? 'todoMyApproval' : 'coursePage'
      const res = await api[apiType](params);
      this.$nextTick(() => {
        this.tableData = res.data.records;
        this.pageInfo.total = res.data.total;
      })

    },
    async handleAction (index, data) {
      switch (index) {
        case 1:
          if (data) {
            const obj = {
              materialFileList: data.row.material.map(item => {
                item.url = data.row.fileKey;
                return item;
              }) || [],
              coverFileList: data.row.cover !== '' ? [{ name: '', url: envConfig.NODE_IMG_API + data.row.cover }] : []
            }
            this.dialogData.form = {
              ...data.row,
              ...obj
            };
          } else this.dialogData.form = { materialFileList: [], coverFileList: [] };
          this.dialogData.title = data ? '编辑' : '添加';
          this.dialogData.visible = true;
          break;
        case 2:
          await api.coursePublish({ courseId: data.row.courseId });
          data.row.publishSign = true;
          this.$message({ message: '发布成功', type: 'success' });
          this.getData()
          break;
        case 3:
          this.dialogData.title = '查看';
          this.dialogData.viewForm = Object.assign(data.row, {});
          this.dialogData.visible = true;
          break;
        case 4:
          await this.$router.push({
            path: '/onlineTraining/courseLearningRecords',
            query: { id: data.row.courseId, courseName: data.row.courseName }
          })
          break;
        case 5:
          await this.$router.push({
            path: '/onlineTraining/reviewManagement',
            query: { id: data.row.courseId, courseName: data.row.courseName }
          })

          break;
        case 6:
          //隐藏
          const params = {
            courseId: data.row.courseId,
            hidden: !data.row.hidden,
          }
          api.hidden(params).then(res => {
            this.$message({ message: '操作成功', type: 'success' });
            this.getData()
          })
          break;
        case 7:
          //审核
          this.dialogData.viewForm = Object.assign(data.row, {});
          this.auditDialog.visible = true;
          this.auditDialog.form = {
            approvalStatus: 'pass',
            approvalReasons: '',
            courseId: data.row.courseId,
          }
          break;
        case 8:
          //分配审核人呢
          this.auditPersonDialog.courseId = data.row.courseId;
          this.auditPersonDialog.visible = true;
          this.auditPersonDialog.userIds = [];
          break;
      }
    },
    //  提交
    submitForm () {
      const data = this.dialogData.form;
      const params = {
        material: data.materialFileList.length > 0 ? data.materialFileList : null,
        cover: data.coverFileList.length > 0 ? data.coverFileList[0].url.replace('/resource', '') : ''
      }
      this.dialogData.form = Object.assign(data, params);
      this.$refs.editForm.$refs.form.validate(async valid => {
        if (!valid) return false;
        // 请求方法
        const url = data.courseId ? 'courseEdit' : 'courseAdd';
        const res = await api[url](this.dialogData.form);
        this.$message({ message: data.courseId ? '编辑成功' : '添加成功', type: 'success' });
        this.dialogData.visible = false;
        await this.getData();
      });
    },
    getFileType (data) {
      let type = '';
      const suffix = data.name.toLowerCase().split('.')[data.name.toLowerCase().split('.').length - 1];
      if (['docx', 'pdf', 'xlsx'].includes(suffix)) {
        type = 'document';
      } else if (['png', 'jpg', 'jpeg'].includes(suffix)) {
        type = 'image';
      } else if (['avi', 'wmv', 'mpeg', 'flv', 'rm', 'mp4'].includes(suffix)) {
        type = 'video';
      }
      return type;
    },
    //  素材上传文件状态改变事件
    async uploadChange (data, file) {
      this.$store.state.loading = true;
      const formatList = ['docx', 'pdf', 'xlsx', 'png', 'jpg', 'jpeg', 'mp4', 'avi', 'wmv', 'mpeg', 'flv', 'rm'];
      const suffix = data.name.toLowerCase().split('.')[data.name.toLowerCase().split('.').length - 1];
      if (!formatList.includes(suffix)) {
        this.$store.state.loading = false;
        this.$message({ message: '请上传正确的格式！', type: 'error' })
        const oldFileList = JSON.parse(JSON.stringify(this.dialogData.form.materialFileList));
        this.$set(this.dialogData.form, 'materialFileList', oldFileList)
        this.$forceUpdate()
        return false;
      }
      // if (!data.name.toLowerCase().includes('mp4') && !data.name.toLowerCase().includes('pdf')) {
      //   this.$store.state.loading = false;
      //   this.$message({ message: '请上传正确的格式！', type: 'error' })
      //   this.dialogData.form.materialFileList = [];
      //   return false;
      // }
      const blobArr = section(data, 10);
      this.uploadFile(blobArr, data)

    },
    async uploadFile (blobArr, data) {
      const hash = await calculateHash(blobArr, 10);
      const res = await uploadChunks(blobArr, hash, data.name);
      if (res === false) {
        this.$message({ message: '文件上传失败，请重新上传', type: 'warning' })
        const oldFileList = JSON.parse(JSON.stringify(this.dialogData.form.materialFileList));
        this.$set(this.dialogData.form, 'materialFileList', oldFileList)
      } else {
        if (res.data.allCompleted) {
          this.dialogData.form.materialFileList.push({
            url: res.data.fileKey,
            fileKey: res.data.fileKey,
            newFileKey: res.data.newFileKey,
            materialType: this.getFileType(data),
            // materialType: data.name.includes('pdf') ? 'document' : 'video',
            name: data.name,
            size: data.size,
            suffix: data.name.split('.')[data.name.split('.').length - 1]
          });
          this.$store.state.loading = false;
        } else {
          if (!res.data.remainIndex) {
            this.uploadFile(blobArr, data)
          }
        }
      }
    },
    //  素材文件删除
    uploadRemove (fileData) {
      const index = this.dialogData.form.materialFileList.findIndex(res => {
        return res.uid === fileData.uid || res.fileKey === fileData.fileKey
      });
      this.dialogData.form.materialFileList.splice(index, 1);
    },
    //  封面上传成功
    handleSuccess (data, file) {
      this.dialogData.form.coverFileList = [{ name: file.name, url: envConfig.NODE_IMG_API + data.data.fileKey }];
      this.$store.state.loading = false;
    },
    //  删除
    handleRemove (fileData) {
      const index = this.dialogData.form.coverFileList.findIndex(res => res.uid === fileData.uid || res.fileKey === fileData.fileKey || res.url === fileData.url);
      this.dialogData.form.coverFileList.splice(index, 1);
    },
    handlePreview (file) {
      this.$store.state.dialogImageUrl = file.url;
      this.$store.state.dialogImageVisible = true;
    },
    //  封面上传限制
    beforeUpload (rawFile, fun) {
      const get = _ => {
        if (!rawFile.name.includes('png') && !rawFile.name.includes('jpg') && !rawFile.name.includes('jpeg')) {
          this.$store.state.loading = false;
          this.$message({ message: '请上传正确的格式！', type: 'error' })
          return false;
        } else if (rawFile.size / 1024 / 1024 > 20) {
          this.$store.state.loading = false;
          this.$message({ message: '超过20MB上传大小！', type: 'error' })
          return false;
        }
        return true;
      };
      fun(get());
    },
    handleSelectionChange (selection) {
      this.checkList = selection;
    },
    handleRowClick (row) {
      console.log('点击行：', row);
    },
    fileReview (url, name, row) {
      this.reviewDialog.url = url;
      if (['avi', 'wmv', 'mpeg', 'flv', 'rm'].includes(row.suffix)) {
        this.reviewDialog.url = '/resource' + row.newFileKey;
      }
      this.reviewDialog.visible = true;
      this.reviewDialog.type = row.suffix;
    },
    removeExam (index, row) {
      api.courseRemove([row.courseId]).then(() => {
        this.$message({ message: '删除成功', type: 'info' });
        this.getData();
      })
    }


  }
}
</script>

<style lang="scss" scoped>
.course-box {
  height: 100%;
  display: flex;
  flex-direction: column;

  .user-search {
    margin-top: 20px;
  }

  .operate {
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }
  }

  .view-list {
    width: 70%;
    margin: 0 auto;
    font-size: 16px;

    .view-item {
      display: flex;
      align-items: flex-start;
      padding: 5px 0;

      .view-label {
        width: 100px;
        text-align: right;
      }
    }
  }
}
</style>

<style lang="scss">
.el-loading-mask {
  z-index: 5000 !important;
}

.fileLimit-box {
  .el-upload--picture-card {
    display: none;
  }
}

.file-right {
  height: 700px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/onlineTraining/course/course.vue